import httpManager from "@/app/shared/utils/httpManager";

export async function fetchAllPortfolios(search = "") {
  const url = `/portfolios/?search=${search}`;
  const response = await httpManager.get(url);
  return response?.data.results;
}
